import React, { useEffect } from "react";
import $ from "jquery";
// import magnificPopup from 'magnific-popup';
import "magnific-popup";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ContactForm from "./ContactForm";
import Testimonials from "./Testimonials";
import brandsList from "../data/brands.json";
import BrandsCard from "./BrandsCard";
import newsList from "../data/news.json";
import LatestNewsCard from "./LatestNewsCard";
import { getTranslatedPath } from "../utils/languageUtils";

const SwiperMobile = () => {
  const { t, i18n } = useTranslation();
  const brandsArray = Object.values(brandsList);
  const newsArray = Object.values(newsList);

  useEffect(() => {
    $(".popup-videos, .popup-border").magnificPopup({
      disableOn: 10,
      type: "iframe",
      title: "popup",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
    });
  }, []);

  const translatedPaths = getTranslatedPath(i18n.language);

  return (
    <div className="swiper-containers">
      <div className="swiper-wrappers">
        <div className="swiper-slide">
          {/* <!-- Banner Section Start --> */}
          {/*<div className="rs-banner banner-home-style3 height-ctrl">
            <div className="container">
              <div className="content-wrap">
                <span className="sub-title">"Galerija" Belgrade</span>
                <h1 className="title">{t("home.title")}</h1>
                <h2 className="title-small">{t("home.titleSmall")}</h2>
                <ul className="banner-bottom">
                  <li>
                      <Link
                        className="readon btn-text ticket text-right"
                        to={`/${i18n.language}/news/black-friday`}
                      >
                        <span>{t("home.read")}</span>
                      </Link>
                  </li>
                  <li>
                    <div className="rs-videos">
                      <div className="animate-border white-color-style">
                        <a
                          className="popup-border"
                          href="https://www.youtube.com/watch?v=XZI0CdEx4vc"
                        >
                          <i className="fa fa-play"></i>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>*/}
          <Link className="hero-link"
                to={`/${i18n.language}/${
                  i18n.language === "en" ? "news" : "vesti"
                }/marc-antoine-barrois-tilia`}
              >      
              <div className="rs-banner banner-home-style3 height-ctrl">
              <video playsinline="playsinline" muted="muted" loop="loop" autoplay="autoplay" preload="metadata" className="video-bg" poster="/assets/images/banner/videos/tilia-thumbnail.jpg">
                  <source src="/assets/images/banner/videos/tilia.mp4" type="video/mp4" />              
                  Your browser does not support the video tag.
                </video>
              </div>
          </Link>
          {/* <!-- Banner Section End --> */}
        </div>
        <div className="swiper-slide">
          {/* <!-- About Section Start --> */}
          <div
            id="rs-about"
            className="rs-about style height-ctrl md-pb-80 md-pt-80"
          >
            <div className="container">
              <div className="row y-middle">
                <div className="col-lg-6 md-mb-70">
                  <div className="about-img">
                    <img
                      src="/assets/images/about/about-2.png"
                      alt="Our Story"
                    />
                  </div>
                </div>
                <div className="col-lg-6 pl-50 md-pl-15">
                  <div className="sec-title">
                    <h2 className="title title2 title3 pb-30">
                      {t("home.story.title")}
                    </h2>
                    <p className="desc-small pb-25">{t("home.story.desc1")} </p>
                    <p className="desc-small">{t("home.story.desc2")}</p>
                    <div className="btn-part mt-40">
                      <Link
                        className="readon btn-text ticket"
                        to={translatedPaths["our-story"]}
                      >
                        <span>{t("home.explore")}</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- About Section End --> */}
        </div>
        <div className="swiper-slide">
          {/* <!-- Boutique Section Start --> */}
          <div
            id="rs-about"
            className="rs-about style height-ctrl md-pb-80 md-pt-80"
          >
            <div className="container">
              <div className="row y-middle">
                <div className="col-lg-6 pl-50 md-pl-15">
                  <div className="sec-title">
                    <h2 className="title title2 title3 pb-30">
                      {t("home.boutique.title")}
                    </h2>
                    <p className="desc-small pb-25">
                      {t("home.boutique.desc1")}{" "}
                    </p>
                    <p className="desc-small">{t("home.boutique.desc2")}</p>
                    <div className="btn-part mt-40">
                      <Link
                        className="readon btn-text ticket"
                        to={translatedPaths["gallery"]}
                      >
                        <span>{t("home.read")}</span>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 md-mb-70">
                  <div className="about-img">
                    <img
                      src="/assets/images/about/about-7.png"
                      alt="Our Story"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- About Section End --> */}
        </div>

        <div className="swiper-slide">
          {/* <!-- Team Section Start --> */}
          <div className="rs-team style7 height-ctrl md-pb-70 md-pt-70">
            <div className="container">
              <div className="sec-title text-center mb-60">
                <h2 className="title title2 title3 text-middle">
                  {t("home.featured.title")}
                </h2>
              </div>
              <OwlCarousel
                className="rs-carousel owl-carousel"
                loop={true}
                items={3}
                margin={30}
                autoplay={true}
                autoplayHoverPause={true}
                autoplayTimeout={5000}
                smartSpeed={800}
                dots={true}
                nav={false}
                navSpeed={false}
                center={false}
                navText={[
                  "<i class='flaticon-left-arrow'></i>",
                  "<i class='flaticon-right-arrow'></i>",
                ]}
                responsive={{
                  0: {
                    items: 1,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  768: {
                    items: 2,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  992: {
                    items: 2,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  1200: {
                    items: 3,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                }}
              >
                <div className="team-item">
                  <div className="team-inner-wrap">
                    <div className="images-wrap">
                      <img src="/assets/images/products/1.jpg" alt="Ganymede" />
                    </div>
                    <div className="team-content">
                      <h3 className="title-name">
                        <a href="#!">Ganymede</a>
                      </h3>
                      <div className="team-title">Marc-Antoine Barrois </div>
                      <div className="team-price">14.000,00 RSD | 30 ml</div>
                    </div>
                  </div>
                </div>
                <div className="team-item">
                  <div className="team-inner-wrap">
                    <div className="images-wrap">
                      <img
                        src="/assets/images/products/2.jpg"
                        alt="Chypre Palatin"
                      />
                    </div>
                    <div className="team-content">
                      <h3 className="title-name">
                        <a href="#!">Chypre Palatin</a>
                      </h3>
                      <div className="team-title">Parfums MDCI</div>
                      <div className="team-price">48.000,00 RSD | 75 ml</div>
                    </div>
                  </div>
                </div>
                <div className="team-item">
                  <div className="team-inner-wrap">
                    <div className="images-wrap">
                      <img
                        src="/assets/images/products/3.jpg"
                        alt="Blanche Bête"
                      />
                    </div>
                    <div className="team-content">
                      <h3 className="title-name">
                        <a href="#!">Blanche Bête</a>
                      </h3>
                      <div className="team-title">Liquides Imaginaires</div>
                      <div className="team-price">30.000,00 RSD | 100 ml</div>
                    </div>
                  </div>
                </div>
                <div className="team-item">
                  <div className="team-inner-wrap">
                    <div className="images-wrap">
                      <img
                        src="/assets/images/products/4.jpg"
                        alt="Incident Diplomatique"
                      />
                    </div>
                    <div className="team-content">
                      <h3 className="title-name">
                        <a href="#!">Incident Diplomatique</a>
                      </h3>
                      <div className="team-title">Jovoy</div>
                      <div className="team-price">18.000,00 RSD | 100 ml</div>
                    </div>
                  </div>
                </div>
                <div className="team-item">
                  <div className="team-inner-wrap">
                    <div className="images-wrap">
                      <img src="/assets/images/products/5.jpg" alt="Team" />
                    </div>
                    <div className="team-content">
                      <h3 className="title-name">
                        <a href="#!">Gozo</a>
                      </h3>
                      <div className="team-title">Jeroboam</div>
                      <div className="team-price">14.000,00 RSD | 30 ml</div>
                    </div>
                  </div>
                </div>
              </OwlCarousel>
            </div>
          </div>
        </div>
        <div className="swiper-slide">
          {/*<!-- Approach Section End -->*/}
          <div className="rs-services style1 bg1 pt-110 pb-60 md-pt-75 md-pb-80">
            <div className="container">
              <div className="sec-title text-center mb-90">
                <h2 className="title title2 title3 text-middle">
                  {t("home.approach.title")}
                </h2>
              </div>
              <div className="row y-middle">
                <div className="col-lg-4 col-md-6 md-mb-30">
                  <div className="services-item">
                    <div className="services-wrap">
                      <div className="services-icon">
                        <img
                          src="/assets/images/approach/1.png"
                          alt="Exclusive perfumes"
                        />
                      </div>
                      <div className="services-text">
                        <h4 className="title">
                          {t("home.approach.principle1.title")}
                        </h4>
                        <p className="services-txt">
                          {t("home.approach.principle1.desc1")}
                          <br />
                          <br />
                          {t("home.approach.principle1.desc2")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 md-mb-30">
                  <div className="services-item">
                    <div className="services-wrap">
                      <div className="services-icon">
                        <img
                          src="/assets/images/approach/2.png"
                          alt="Bespoke approach"
                        />
                      </div>
                      <div className="services-text">
                        <h4 className="title">
                          {t("home.approach.principle2.title")}
                        </h4>
                        <p className="services-txt">
                          {t("home.approach.principle2.desc1")}
                          <br />
                          <br />
                          {t("home.approach.principle2.desc2")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="services-item">
                    <div className="services-wrap">
                      <div className="services-icon">
                        <img
                          src="/assets/images/approach/3.png"
                          alt="Immersive Luxury"
                        />
                      </div>
                      <div className="services-text">
                        <h4 className="title">
                          {t("home.approach.principle3.title")}
                        </h4>
                        <p className="services-txt">
                          {t("home.approach.principle3.desc1")}
                          <br />
                          <br />
                          {t("home.approach.principle3.desc2")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*<!-- Approach Section End -->*/}
        </div>
        <div className="swiper-slide">
          {/* <!-- Our Brands Section Start --> */}
          <div
            id="rs-our-sponsor"
            className="rs-our-sponsor style1 home3-sponsor-style height-ctrl md-pb-70 md-pt-70"
          >
            <div className="container">
              <div className="sec-title text-center mb-60">
                <h2 className="title title2 title3 text-middle">
                  {t("home.brands.title")}
                </h2>
              </div>
              <div className="row">
                {brandsArray.map((brand) => (
                  <BrandsCard key={brand.title} brand={brand} />
                ))}
              </div>
            </div>
          </div>
          {/* <!-- Our Brands Section End --> */}
        </div>
        <div className="swiper-slide">
          {/* <!-- News Section Start --> */}
          <div
            id="rs-blog"
            className="rs-blog blog-main-home home3-blog-style height-ctrl md-pb-70 md-pt-70"
          >
            <div className="container">
              <div className="sec-title text-center mb-60 md-mb-40">
                <h2 className="title title2 title3 text-middle">
                  {t("home.news.title")}
                </h2>
              </div>
              <OwlCarousel
                className="rs-carousel owl-carousel"
                loop={true}
                items={3}
                margin={30}
                autoplay={true}
                autoplayHoverPause={true}
                autoplayTimeout={5000}
                smartSpeed={800}
                dots={true}
                nav={false}
                navSpeed={false}
                center={false}
                navText={[
                  "<i class='flaticon-left-arrow'></i>",
                  "<i class='flaticon-right-arrow'></i>",
                ]}
                responsive={{
                  0: {
                    items: 1,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  768: {
                    items: 2,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  992: {
                    items: 2,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  1200: {
                    items: 3,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                }}
              >
                {newsArray.map((news) => (
                  <LatestNewsCard key={news.title} news={news} />
                ))}
              </OwlCarousel>
            </div>
          </div>
          {/* <!-- Blog Section End --> */}
        </div>
        <div className="swiper-slide">
          {/* <!-- Testimonials Section Start --> */}
          <Testimonials />
          {/* <!-- Testimonials Section End -->   */}
        </div>
        <div className="swiper-slide">
          {/* <!-- Contact Section Start --> */}
          <div className="rs-contact home-style1 home-style3 contact-home-style3 height-ctrl md-pb-70 md-pt-70">
            <div className="container">
              <div className="sec-title text-center mb-60 md-mb-40">
                <h2 className="title title2 title3 text-middle">
                  {t("home.contact.title")}
                </h2>
              </div>
              <div className="row y-middle">
                <div className="col-lg-8 pr-130 md-pr-15">
                  <div className="contact-img md-mb-50">
                    <img
                      src="/assets/images/contact/contact-1.png"
                      alt="Get in touch with us"
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="widget-item mb-20">
                    <div className="address-item">
                      <div className="address-icon">
                        <img
                          src="/assets/images/contact/icons/1.png"
                          alt="Images"
                        />
                      </div>
                      <div className="address-text">
                        <h3 className="title">{t("home.contact.visit")}</h3>
                        <p className="services-txt">
                          TC "Galerija" (entrance 3.)
                          <br />
                          Bulevar Vudroa Vilsona 14
                          <br />
                          11000 Belgrade
                          <br />
                          Serbia
                          <br />
                          <br />
                          <Link
                          to={translatedPaths["contact"]}
                          >
                            <span>{t("home.contact.location")} &raquo;</span>
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="widget-item mb-20">
                    <div className="address-item">
                      <div className="address-icon">
                        <img
                          src="/assets/images/contact/icons/2.png"
                          alt="Email us"
                        />
                      </div>
                      <div className="address-text">
                        <h3 className="title">{t("home.contact.email")}</h3>
                        <p className="services-txt">
                          <a href="mailto:info@parfimerija-duro.rs">
                            info@parfimerija-duro.rs
                          </a>
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="widget-item">
                    <div className="address-item">
                      <div className="address-icon">
                        <img
                          src="/assets/images/contact/icons/3.png"
                          alt="Call us"
                        />
                      </div>
                      <div className="address-text">
                        <h3 className="title">{t("home.contact.call")}</h3>
                        <p className="services-txt">
                          <a href="tel:+381 60 5561303">+381 60 5561303</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Contact Section End -->   */}
        </div>
        <div className="swiper-slide">
          {/* <!-- Contact Section Start --> */}
          <div className="rs-contact home-style1 home-style3 contact-home-style4 height-ctrl md-pb-50 md-pt-40">
            <div className="container">
              <div className="sec-title text-center mb-60 md-mb-40">
                <h2 className="title title2 title3 text-middle">
                  {t("home.contact.contact")}
                </h2>
              </div>
              {/* <!-- Contact Section Start --> */}
              <div className="rs-contact">
                <div className="row y-middle">
                  <div className="col-lg-6 pr-40 md-pr-15 md-mb-50">
                    <div className="contact-map">
                      <iframe
                        title="Location"
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11323.815743977078!2d20.4463451!3d44.8021274!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a71158f3b75d9%3A0x3cdfdea1cf3307be!2sDUR%C5%8C%20%7C%20Niche%20perfumery!5e0!3m2!1sen!2srs!4v1681389080409!5m2!1sen!2srs"
                      ></iframe>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="contact-wrap">
                      <div id="form-messages"></div>
                      <ContactForm />
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Contact Section End --> */}

              <div className="copyright text-center pt-25">
                <p>
                  {t("footer.footerHome.heartBefore")}{" "}
                  <i className="fa fa-heart"></i>{" "}
                  {t("footer.footerHome.heartAfter")}
                  <a href="https://intellect.se">Intellect</a>.
                </p>
              </div>
              {/*<div className="footer-logo text-center pt-10">
                <img src="/assets/images/duro_sign_light.svg" alt="DURŌ" />
              </div>*/}
            </div>
          </div>
          {/* <!-- Contact Section End -->  */}
        </div>
      </div>
    </div>
  );
};
export default SwiperMobile;
